import {
  SensorTypeInput
}  from 'src/services/graphql/Models';
import Configuration from './Configuration';
import ConditionalState from './ConditionalState';
import ActionDefinition from './ActionDefinition';
import { DataClass } from 'src/shared/utility';

export default class SensorType implements SensorTypeInput, DataClass {
  clientId: string;
  typedId: string;
  icon?: string | null;
  name: string;
  isStateBased?: boolean | null;
  possibleStates?: Array< string | null > | null;
  measurement: string;
  commUnit: string;
  maxValue?: number | null;
  minValue?: number | null;
  significantDifference?: number | null;
  significantTimeDifference?: number | null;
  configurations?: Array< Configuration | null > | null;
  conditionalState?: Array< ConditionalState | null > | null;
  possibleActions?: Array< ActionDefinition | null > | null;
  isOutput: boolean;

  constructor(from: any) {
    this.clientId = from.clientId;
    this.typedId = from.typedId;
    
    this.icon = from.icon;
    this.name = from.name;
    
    this.isStateBased = from.isStateBased;
    this.possibleStates = from.possibleStates;

    this.measurement = from.measurement;
    
    this.commUnit = from.commUnit;
    this.maxValue = from.maxValue;
    this.minValue = from.minValue;
    
    this.significantDifference = from.significantDifference;
    this.significantTimeDifference = from.significantTimeDifference;
    
    this.isOutput = from.isOutput;
    this.configurations = from.configurations;
    this.conditionalState = from.conditionalState;
    this.possibleActions = from.possibleActions;
  }
      
  isSensorType ( sensorName: string ) {
    try {
      if ( !this.typedId || !this.typedId.includes(':') ) {
          throw new Error();
      }
  
      const _sensorAlias = this.typedId.split(':')[1];
      const sensorAliases = _sensorAlias.toLowerCase()
          .split(' ')
          .join('')
          .split(',');
      // return sensorAliases.some(sensorAlias => sensorName.toLowerCase().includes(sensorAlias));
      const index = sensorAliases.findIndex(sensorAlias => sensorName.toLowerCase().includes(sensorAlias));
      return index < 0 ? Number.MAX_SAFE_INTEGER : index;
    } catch (e) {
        return Number.MAX_SAFE_INTEGER;
    }
  }

  parseAbsolute() {
    return {
      clientId: this.clientId,
      typedId: this.typedId,
      
      icon: this.icon,
      name: this.name,
      
      isStateBased: this.isStateBased,
      possibleStates: this.possibleStates,

      measurement: this.measurement,
      
      commUnit: this.commUnit,
      maxValue: this.maxValue,
      minValue: this.minValue,
      
      significantDifference: this.significantDifference,
      significantTimeDifference: this.significantTimeDifference,
      
      isOutput: this.isOutput,
      configurations: (this.configurations || []).map(o => o.parseAbsolute()),
      conditionalState: (this.conditionalState || []).map(o => o.parseAbsolute()),
      possibleActions: (this.possibleActions || []).map(o => o.parseAbsolute())
    };
  }
}

export function findSensorType(parsedSensor: SensorType[], USA: string) {
  try {
      const sensorIndex = parsedSensor.reduce(
          (aind: number, b: SensorType, bind: number) => {
              if (aind < 0) {
                  if ( b.isSensorType(USA) !== Number.MAX_SAFE_INTEGER ) {
                      return bind;
                  } else {
                      return aind;
                  }
              }
              
              const a = parsedSensor[aind];
          
              if (a.isSensorType(USA) < b.isSensorType(USA)) {
                  return aind;
              } else {
                  return bind;
              }
          },
          -1
      );

      if (sensorIndex >= 0) {
          return parsedSensor[sensorIndex];
      }
  } catch (e) {
      console.error(e);
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/stores/application/classes/SensorType.ts